import {
    HIDE_NOTIFICATION,
    SHOW_NOTIFICATION,
    TOGGLE_SIDEBAR,
} from 'store/actions/types';

export const toggleSidebar = () => {
    return {
        type: TOGGLE_SIDEBAR,
    };
};

export const showNotification = (text, type) => {
    type = type || 'info';

    return {
        type: SHOW_NOTIFICATION,
        payload: {
            text: text,
            type: type,
        },
    };
};

export const hideNotification = () => {
    return {
        type: HIDE_NOTIFICATION,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/uiActions.js